// extracted by mini-css-extract-plugin
export default {"Wrapper":"toast_Wrapper__Q7kJE","Title":"toast_Title__K7w6-","Info":"toast_Info__KLJAQ","Error":"toast_Error__dVwvS","Success":"toast_Success__myr83"};